$(document).ready(function() {
    if (innerWidth > 1247) {
        let stickynav = $(".stickynav");

        if (stickynav[0]) {
            let utility = $(".navigation-utility");
            let nav = $(".navigation-primary");
            let contPosition = $(".row-content").offset();
            let toggleCont = $(".js-toggle");
            let position = stickynav.position();
            let top = position.top + 20;

            let utilityHeight = utility.innerHeight() - 60;
            let navheight = nav.innerHeight();
            let setTop = utilityHeight + navheight + 20;
            let triggerPoint = contPosition.top - setTop ;

            $(".js-dropdown").on("click", function() {
                setTimeout(function() {
                    position = stickynav.position();
                    top = position.top + 20;
                }, 400);
            });
            
            $(window).scroll(function() {
                let scrollTop = this.scrollY;
                setScroll(scrollTop);
            });

            function setScroll(scrollTop) {
                utilityHeight = toggleCont.is(":visible")? utility.innerHeight() : (utility.innerHeight() - 60);
                navheight = nav.innerHeight();
                setTop = utilityHeight + navheight + 20;

                $(".js-dropdown").on("click", function() {
                    setTimeout(function() {
                        position = stickynav.position();
                        top = position.top + 20;
                    }, 400);
                });

                if (scrollTop >= triggerPoint) {
                    stickynav.css({
                        top: setTop + "px"
                    });
                    stickynav
                        .removeClass("sticky-default")
                        .addClass("sticky-fixed");
                } else {
                    stickynav
                        .removeClass("sticky-fixed")
                        .addClass("sticky-default");
                }
            }
        }
    }
});